import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBezierEdit: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"bezier--edit"} maskId="square-filled-radius-0-stroke-1-IconBezierEdit"><path fillRule="evenodd" clipRule="evenodd" d="M17.3964 13.5631C18.236 12.7235 19.5973 12.7235 20.4369 13.5631C21.2765 14.4027 21.2765 15.764 20.4369 16.6035L16.0404 21H13V17.9596L17.3964 13.5631Z" fill="currentColor"/><path d="M3 3V9H5.5V15H3V21H9V18.5H11V17.5H9V15H6.5V9H9V6.5H15V9H17.5V11H18.5V9H21V3H15V5.5H9V3H3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBezierEdit;
